const norm = (s) =>
  String(s || "")
    .trim()
    .toLowerCase();

export function pickDisplayPrice(product, currency, pickedVariantName) {
  const scope = currency === "TRY" ? "tr" : "intl";

  // küçük helper: aynı fiyat çözme mantığını dp üstünden uygula
  const resolveFromDisplayPrices = (dp) => {
    if (!dp) return null;

    // 1) İstenen currency
    let val = dp?.[scope]?.[currency];
    if (val != null) return { amount: Number(val), curr: currency };

    // 2) Aynı scope içinde USD fallback
    val = dp?.[scope]?.USD;
    if (val != null) return { amount: Number(val), curr: "USD" };

    // 3) Global fallback: intl.USD
    val = dp?.intl?.USD;
    if (val != null) return { amount: Number(val), curr: "USD" };

    return null;
  };

  // 0) ✅ Varyasyon varsa ÖNCE varyasyonun displayPrices'ını kullan
  const variants = product?.color_images;
  if (Array.isArray(variants) && variants.length) {
    const chosen =
      (pickedVariantName
        ? variants.find((v) => norm(v?.name) === norm(pickedVariantName))
        : null) || variants[0];

    const fromVariantDp = resolveFromDisplayPrices(chosen?.displayPrices);
    if (fromVariantDp) return fromVariantDp;
  }

  // 1) ✅ Product displayPrices
  const fromProductDp = resolveFromDisplayPrices(product?.displayPrices);
  if (fromProductDp) return fromProductDp;

  // 2) Legacy price
  const legacy = product?.price;
  if (legacy != null && legacy !== "") {
    const n = Number(String(legacy).replace(/\./g, "").replace(",", "."));
    if (!Number.isNaN(n)) return { amount: n, curr: currency };
  }

  return null;
}

export function formatMoney(amount, curr, opts = { min: 0, max: 0 }) {
  return `${Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: opts.min,
    maximumFractionDigits: opts.max,
  })} ${curr}`;
}
